interface GetFormattedAmountOptions {
  amount: number;
  currency: string;
  region?: string;
}

const getFormattedAmount = ({
  amount,
  region = 'en-US',
  currency
}: GetFormattedAmountOptions) => {
  return new Intl.NumberFormat(region, {
    style: 'currency',
    currency,
    minimumFractionDigits: amount % 1 > 0 ? 2 : 0,
    maximumFractionDigits: 4
  }).format(amount);
};

export default getFormattedAmount;
